var _rect, _rect2, _rect3, _rect4, _rect5, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#FFC77F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#FFC77F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "url(#paint0_linear_5_5533)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "url(#paint1_linear_5_5533)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#FF6E01"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22L19 16L13 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_5533",
    x1: 0,
    y1: 16,
    x2: 31.3846,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CDCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29EAC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_5533",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5412C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow26);
export default __webpack_public_path__ + "static/media/right-arrow-26.07797542851e4326c142a5897365ff11.svg";
export { ForwardRef as ReactComponent };